import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import './app/core/icons';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    // eslint-disable-next-line no-console -- bootstrap failure: logger unavailable
    console.error(err),
);
